"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueValue = exports.isLocalizedValue = exports.getValue = exports.FieldPreviewValue = exports.useStyles = exports.getFieldType = exports.PkpassFieldTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _FieldPreviewValueCurrency = _interopRequireDefault(require("./types/FieldPreviewValueCurrency"));

var _FieldPreviewValueDate = _interopRequireDefault(require("./types/FieldPreviewValueDate"));

var _FieldPreviewValueNumber = _interopRequireDefault(require("./types/FieldPreviewValueNumber"));

var _usePkpass2 = require("../../../usePkpass");

var _types = require("../../../../../../types");

var _Theme = require("../../../../Theme");

var _reactJss = require("react-jss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PkpassFieldTypes;
exports.PkpassFieldTypes = PkpassFieldTypes;

(function (PkpassFieldTypes) {
  PkpassFieldTypes["Number"] = "number";
  PkpassFieldTypes["Date"] = "date";
  PkpassFieldTypes["Currency"] = "currency";
  PkpassFieldTypes["Text"] = "text";
})(PkpassFieldTypes || (exports.PkpassFieldTypes = PkpassFieldTypes = {}));

var getFieldType = function getFieldType(field) {
  if (field.currencyCode) {
    return PkpassFieldTypes.Currency;
  }

  if (field.numberStyle) {
    return PkpassFieldTypes.Number;
  }

  if (field.dateStyle || field.timeStyle) {
    return PkpassFieldTypes.Date;
  }

  return PkpassFieldTypes.Text;
};

exports.getFieldType = getFieldType;
var useStyles = (0, _reactJss.createUseStyles)({
  backfield: {
    color: '#7d7d7d',
    marginBottom: function marginBottom(_ref) {
      var theme = _ref.theme;
      return theme.scale * 10;
    },
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    fontSize: function fontSize(_ref2) {
      var theme = _ref2.theme;
      return theme.scale * 16;
    }
  },
  field: {
    color: function color(_ref3) {
      var foregroundColor = _ref3.foregroundColor;
      return foregroundColor;
    },
    fontSize: function fontSize(_ref4) {
      var _fontSize = _ref4.fontSize,
          theme = _ref4.theme;
      return "".concat(_fontSize * theme.scale, "%");
    },
    height: function height(_ref5) {
      var theme = _ref5.theme;
      return theme.scale * 26;
    },
    lineHeight: function lineHeight(_ref6) {
      var theme = _ref6.theme;
      return "".concat(theme.scale * 22, "px");
    },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
});
exports.useStyles = useStyles;

var FieldPreviewValue = function FieldPreviewValue(props) {
  var field = props.field,
      fieldsType = props.fieldsType;

  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      passStyle = _usePkpass.passStyle,
      pass = _usePkpass.pass,
      language = _usePkpass.language;

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    theme: theme,
    foregroundColor: pass.foregroundColor,
    fontSize: getFontSize(field, fieldsType, pass, passStyle, language)
  });
  var val = getValueValue(field, language);
  var content = _types.PkpassFieldsType.BackFields === fieldsType ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(val)
    }
  }) : /*#__PURE__*/React.createElement("span", null, val);
  var fieldType = getFieldType(field);

  if (fieldType === PkpassFieldTypes.Date) {
    content = /*#__PURE__*/React.createElement(_FieldPreviewValueDate.default, {
      value: "".concat(val),
      dateStyle: field.dateStyle,
      timeStyle: field.timeStyle
    });
  }

  if (fieldType === PkpassFieldTypes.Number && (0, _lodash.isNumber)(val)) {
    content = /*#__PURE__*/React.createElement(_FieldPreviewValueNumber.default, {
      value: val,
      style: field.numberStyle
    });
  }

  if (fieldType === PkpassFieldTypes.Currency && (0, _lodash.isNumber)(val)) {
    content = /*#__PURE__*/React.createElement(_FieldPreviewValueCurrency.default, {
      language: language,
      value: val,
      currency: field.currencyCode
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: _types.PkpassFieldsType.BackFields === fieldsType ? classes.backfield : classes.field
  }, content);
};

exports.FieldPreviewValue = FieldPreviewValue;

var getValue = function getValue(field) {
  return field.attributedValue || field.value;
};

exports.getValue = getValue;

var isLocalizedValue = function isLocalizedValue(field) {
  return (0, _lodash.isObject)(field.attributedValue || field.value);
};

exports.isLocalizedValue = isLocalizedValue;

var getValueValue = function getValueValue(field, language) {
  var v = getValue(field);

  if ((0, _lodash.isObject)(v) && !(0, _lodash.isDate)(v)) {
    return v[language];
  }

  return v;
};

exports.getValueValue = getValueValue;

var getFieldValueLenght = function getFieldValueLenght(f, language) {
  if (f.value) {
    var v = f.value;
    var value = (0, _lodash.isObject)(v) && !(0, _lodash.isDate)(v) ? "".concat(v[language]) : "".concat(v);

    if (value) {
      return "".concat(value).length;
    }
  }

  return 0;
}; // TODO - don't use chars but real width of rendered element.


var getFontSize = function getFontSize(f, fieldsType, pass, passStyle, language) {
  if (_types.PkpassFieldsType.BackFields === fieldsType) {
    return 16;
  }

  var MAX_FONT_SIZE = 125;
  var MIN_FONT_SIZE = 75;
  var MAX_CHARS_IN_FIELD = 8;
  var valueCount = 0;

  if (passStyle === _types.PkpassPassStyleTypes.Coupon || passStyle === _types.PkpassPassStyleTypes.StoreCard) {
    var MAX_COUNT = 4;
    var secondaryFields = pass[passStyle].secondaryFields || [];
    var auxiliaryFields = pass[passStyle].auxiliaryFields || [];
    var totalCount = auxiliaryFields.length + secondaryFields.length;

    if (totalCount) {
      secondaryFields.forEach(function (f) {
        valueCount += getFieldValueLenght(f, language);
      });
      auxiliaryFields.forEach(function (f) {
        valueCount += getFieldValueLenght(f, language);
      });
    }

    return Math.min(MAX_FONT_SIZE, Math.max(MAX_CHARS_IN_FIELD * MAX_COUNT / valueCount * 100, MIN_FONT_SIZE));
  }

  var fields = pass[passStyle][fieldsType] || [];
  var fieldSize = fields.length || 0;

  if (fieldSize) {
    fields.forEach(function (f) {
      valueCount += getFieldValueLenght(f, language);
    });
  }

  return Math.min(MAX_FONT_SIZE, Math.max(MAX_CHARS_IN_FIELD * fields.length / valueCount * 100, MIN_FONT_SIZE));
};
//# sourceMappingURL=FieldPreviewValue.js.map